import type { BucketedVariation as ConvertBucketedVariation } from "@convertcom/js-sdk-types/lib/types";

import TelemetryClient from "../../Telemetry/compositions/TelemetryClient";
import EnvironmentConfiguration from "../../types/EnvironmentConfiguration";
import { ConvertMalformedVariationEvent } from "./ConvertTelemetryEvents";
import ExperimentConfiguration from "./ExperimentConfiguration";

/** An {@link ExperimentConfiguration} for use with Convert.com experiments. */
class ConvertExperimentConfiguration extends ExperimentConfiguration {
  /**
   * Initializes a new instance of the {@link ConvertExperimentConfiguration} class.
   * @param experimentId - The primary identifier of the experiment.
   * @param variation - The Convert.com bucketed variation to configure the experiment with.
   * @remarks The experiment is active if the selected variations's external identifier is not within the configured
   * list of default variation identifiers, but this decision is inverted if the received variation is not running.
   */
  constructor(experimentId: string, variation: ConvertBucketedVariation) {
    const variationId = variation.id;
    const variationStatus = variation.status;

    if (typeof variationId !== "string" || variationId.length === 0 || typeof variationStatus !== "string") {
      TelemetryClient.traceEvent(
        new ConvertMalformedVariationEvent(experimentId, (variation as Record<string, unknown>) || null)
      );
      super(experimentId, false);
      return;
    }

    const isVariationDefault = EnvironmentConfiguration.convertDotCom.defaultVariationIds.includes(variationId);
    const isVariationRunning = variationStatus === "running";

    super(experimentId, isVariationRunning ? !isVariationDefault : isVariationDefault);
  }
}

export default ConvertExperimentConfiguration;
